import { render, staticRenderFns } from "./SidebarFull.vue?vue&type=template&id=ac18fe2a&"
import script from "./SidebarFull.vue?vue&type=script&lang=ts&"
export * from "./SidebarFull.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarFull.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VListItem,VListItemAction,VListItemTitle,VNavigationDrawer})
